<div id="dismissible" role="dialog" #containerDiv
	aria-labelledby="dismissible-title" aria-modal="true" 
	class="nsw-dialog js-dialog js-dialog-dismiss active">
	<div class="nsw-dialog__wrapper">
		<div class="nsw-dialog__container">
			<div class="nsw-dialog__top">
				<div class="nsw-dialog__title">
					<h2 id="dismissible-title" [tabindex]="0" style="color:black;">{{data?.title}}</h2>                        
				</div>
				<div class="nsw-dialog__close" *ngIf="data?.showCloseButton" >
					<button class="nsw-icon-button js-close-dialog" (click)="onCancelClicked($event)">
						<span class="material-icons nsw-material-icons" focusable="false"
							aria-hidden="true">close</span>
						<span class="sr-only">Close</span>
					</button>
				</div>
			</div>
			<div class="nsw-dialog__content">                    
				<p style="color:black;" [tabindex]="0">{{data?.content}}</p>
			</div>
		</div>
		<div class="nsw-dialog__bottom">
			<button *ngIf="data?.showCancelButton || data?.cancelButtonText" 
				role="button" 
				class="nsw-button nsw-button--dark js-close-dialog" 
				autofocus 
				(click)="onCancelClicked($event)">
				{{data?.cancelButtonText}}
			</button>
			<button 
				role="button" 
				class="nsw-button nsw-button--dark-outline-solid js-close-dialog" 
				(click)="onAcceptClicked($event)"
				[attr.autofocus]="!data?.showCancelButton ? '' : null">
				{{data?.acceptButtonText}}
			</button>
			
		</div>
	</div>
</div>